const translations = {
  // Navbar
  "nav.about": "Sobre",
  "nav.services": "Serviços",
  "nav.infrastructure": "Infraestrutura",
  "nav.quote": "Pedir Orçamento",

  // Hero
  "hero.badge": "Soluções Digitais Premium",
  "hero.title1": "Onde criatividade",
  "hero.title2": "encontra",
  "hero.title3": "performance",
  "hero.subtitle": "Soluções digitais criativas para transformar a presença online das empresas",
  "hero.cta.quote": "Pedir Orçamento",
  "hero.cta.services": "Ver Serviços",

  // About
  "about.label": "Sobre Nós",
  "about.title1": "Transformamos ideias em",
  "about.title2": "experiências digitais",
  "about.p1": "A MidiaHost é uma empresa especializada em soluções digitais, unindo design criativo para transformar ideias em experiências digitais de alto impacto. Com sede em Portugal, somos apaixonados por criar websites que não só se destacam pelo visual moderno, mas que também são eficazes em gerar resultados concretos para os nossos clientes.",
  "about.p2": "Com uma abordagem centrada no cliente, desenvolvemos projetos personalizados que refletem a identidade única de cada marca. Do design responsivo ao desenvolvimento funcional, cada detalhe é pensado para garantir uma presença online forte, intuitiva e otimizada.",
  "about.p3": "Além da criação de websites, a MidiaHost conta com uma parceria estratégica com a SkyHost, empresa responsável pela infraestrutura de hospedagem e serviços em nuvem. Trabalhamos lado a lado com empresas de diferentes setores, ajudando-as a crescer no mundo digital com soluções adaptadas às suas necessidades.",
  "about.stat1.value": "100+",
  "about.stat1.label": "Projetos Entregues",
  "about.stat2.value": "50+",
  "about.stat2.label": "Clientes Satisfeitos",
  "about.stat3.value": "5+",
  "about.stat3.label": "Anos de Experiência",

  // Services
  "services.label": "Serviços",
  "services.title": "O que fazemos por si",
  "services.subtitle": "Soluções digitais completas para elevar a sua presença online",
  "services.learnMore": "Saber mais",
  "services.s1.title": "Websites One Page",
  "services.s1.desc": "Sites modernos de página única, perfeitos para apresentações diretas e impactantes",
  "services.s2.title": "Websites Informativos",
  "services.s2.desc": "Plataformas completas para apresentar a sua empresa de forma profissional",
  "services.s3.title": "E-commerce",
  "services.s3.desc": "Lojas online otimizadas para vender os seus produtos com eficiência",
  "services.s4.title": "Identidade Visual",
  "services.s4.desc": "Criação de logótipos e elementos visuais que representam a sua marca",
  "services.s5.title": "Materiais Promocionais",
  "services.s5.desc": "Design de materiais digitais e físicos para promover o seu negócio",
  "services.s6.title": "Design para Impressão",
  "services.s6.desc": "Flyers, banners e outros materiais gráficos de alta qualidade",
  "services.s7.title": "Fotografia",
  "services.s7.desc": "Cobertura fotográfica profissional para os seus eventos e projetos",
  "services.s8.title": "Videografia",
  "services.s8.desc": "Produção de vídeos profissionais para contar a história da sua marca",
  "services.s9.title": "Streaming ao Vivo",
  "services.s9.desc": "Transmissões ao vivo de alta qualidade para os seus eventos",

  // Infrastructure
  "infra.title": "Infraestrutura de nível empresarial",
  "infra.p1": "A MidiaHost disponibiliza uma nuvem privada própria, pensada exclusivamente para entregar projetos de forma segura, rápida e personalizada aos seus clientes. Em parceria estratégica com a SkyHost, garantimos infraestrutura de hospedagem e serviços em nuvem de excelência.",
  "infra.p2": "Esta combinação única permite-nos oferecer soluções digitais completas, desde o design até à hospedagem, tudo num só lugar com a máxima qualidade e confiabilidade.",
  "infra.f1.title": "Nuvem Privada",
  "infra.f1.desc": "Infraestrutura exclusiva para os seus projetos",
  "infra.f2.title": "Segurança Avançada",
  "infra.f2.desc": "Proteção de dados e backups automáticos",
  "infra.f3.title": "Performance Otimizada",
  "infra.f3.desc": "Velocidade e estabilidade garantidas",
  "infra.f4.title": "Suporte 24/7",
  "infra.f4.desc": "Assistência técnica sempre disponível",

  // Why Choose
  "why.label": "Vantagens",
  "why.title": "Porquê escolher a MidiaHost",
  "why.b1.title": "Design que converte",
  "why.b1.desc": "Criamos experiências visuais que não só impressionam, mas também geram resultados concretos para o seu negócio",
  "why.b2.title": "Soluções Personalizadas",
  "why.b2.desc": "Cada projeto é único e desenvolvido à medida das suas necessidades específicas",
  "why.b3.title": "Suporte Dedicado",
  "why.b4.title": "Performance Otimizada",
  "why.b4.desc": "Websites rápidos, responsivos e otimizados para todos os dispositivos e motores de busca",
  "why.b5.title": "Experiência digital profissional de ponta a ponta",
  "why.b5.desc": "Da estratégia ao lançamento, acompanhamos cada etapa do seu projeto digital",

  // Contact
  "contact.title": "Vamos conversar",
  "contact.subtitle": "Pronto para transformar a sua presença digital? Entre em contacto connosco e descubra como podemos ajudar o seu negócio a crescer online.",
  "contact.email.label": "Email",
  "contact.phone.label": "Telefone",
  "contact.location.label": "Localização",
  "contact.location.value": "Portugal",
  "contact.social.label": "Siga-nos",
  "contact.form.name": "Nome completo",
  "contact.form.email": "Email",
  "contact.form.company": "Empresa (opcional)",
  "contact.form.message": "Mensagem",
  "contact.form.submit": "Enviar mensagem",
  "contact.form.sending": "A enviar...",
  "contact.form.success": "Mensagem enviada com sucesso! Entraremos em contacto em breve.",
  "contact.form.error": "Erro ao enviar mensagem. Por favor, tente novamente.",

  // Footer
  "footer.slogan": "Onde criatividade encontra performance",
  "footer.desc": "Soluções digitais criativas para transformar a presença online das empresas",
  "footer.newsletter.title": "Novidades",
  "footer.newsletter.desc": "Subscreva para receber as últimas novidades",
  "footer.newsletter.placeholder": "O seu email",
  "footer.newsletter.privacy": "Respeitamos a sua",
  "footer.newsletter.privacyLink": "privacidade",
  "footer.services.title": "Serviços",
  "footer.services.websites": "Criação de Websites",
  "footer.services.design": "Design Gráfico",
  "footer.services.ecommerce": "E-commerce",
  "footer.services.events": "Cobertura de Eventos",
  "footer.services.cloud": "Infraestrutura Cloud",
  "footer.social.title": "Siga-nos",
  "footer.copyright": "Todos os direitos reservados.",
  "footer.privacy": "Privacidade",
  "footer.terms": "Termos",

  // CTA Section
  "cta.title": "Pronto para transformar a sua presença digital?",
  "cta.subtitle": "Junte-se às empresas que já confiam na MidiaHost para crescer no mundo digital.",
  "cta.button": "Pedir Orçamento",

  // Service Pages
  websitesOnePage: {
    title: 'Websites One Page',
    subtitle: 'Websites modernos de página única para apresentação rápida e comunicação direta',
    description: 'Criamos websites one page profissionais, ideais para empresas que precisam de uma presença online impactante e direta. Perfeito para landing pages, portfolios e apresentações de produtos ou serviços.',
    includes: {
      title: 'O que inclui',
      items: [
        { title: 'Design Responsivo', desc: 'Layout adaptável a todos os dispositivos e tamanhos de ecrã' },
        { title: 'Navegação Suave', desc: 'Scroll animado entre secções para melhor experiência' },
        { title: 'Otimização SEO', desc: 'Estrutura otimizada para motores de busca' },
        { title: 'Formulário de Contacto', desc: 'Sistema integrado para receber mensagens' },
        { title: 'Integração Redes Sociais', desc: 'Links e widgets das suas redes sociais' },
        { title: 'Performance Otimizada', desc: 'Carregamento rápido e eficiente' }
      ]
    },
    process: {
      title: 'Como trabalhamos',
      steps: [
        { title: 'Briefing', desc: 'Reunião inicial para entender os seus objetivos e necessidades' },
        { title: 'Planeamento', desc: 'Definição da estrutura, conteúdos e funcionalidades' },
        { title: 'Design', desc: 'Criação do layout visual alinhado com a sua marca' },
        { title: 'Desenvolvimento', desc: 'Programação e implementação de todas as funcionalidades' },
        { title: 'Testes', desc: 'Verificação de compatibilidade e performance' },
        { title: 'Lançamento', desc: 'Publicação do website e formação de utilização' }
      ]
    },
    portfolio: {
      title: 'Projetos anteriores',
      subtitle: 'Exemplos de websites one page que criámos'
    },
    benefits: {
      title: 'Benefícios',
      items: [
        { title: 'Comunicação Direta', desc: 'Mensagem clara e objetiva numa única página' },
        { title: 'Conversão Otimizada', desc: 'Estrutura focada em gerar leads e vendas' },
        { title: 'Fácil Manutenção', desc: 'Atualização simples de conteúdos' },
        { title: 'Custo-Benefício', desc: 'Solução profissional com investimento acessível' }
      ]
    },
    cta: {
      title: 'Pronto para ter o seu website one page?',
      subtitle: 'Entre em contacto connosco e receba um orçamento personalizado',
      button: 'Pedir Orçamento'
    }
  },

  websitesInformativos: {
    title: 'Websites Informativos',
    subtitle: 'Websites profissionais para empresas que querem apresentar o seu negócio online',
    description: 'Desenvolvemos websites informativos completos e profissionais para empresas que precisam de uma presença digital sólida. Ideal para apresentar serviços, credibilidade e informações institucionais.',
    includes: {
      title: 'O que inclui',
      items: [
        { title: 'Múltiplas Páginas', desc: 'Estrutura completa com várias secções e páginas' },
        { title: 'Sistema de Gestão', desc: 'Painel administrativo para gerir conteúdos' },
        { title: 'Blog Integrado', desc: 'Área de notícias e artigos para SEO' },
        { title: 'Galeria de Imagens', desc: 'Showcase visual dos seus projetos e trabalhos' },
        { title: 'Formulários Avançados', desc: 'Contacto, orçamentos e outras funcionalidades' },
        { title: 'Certificado SSL', desc: 'Segurança e confiança para os visitantes' }
      ]
    },
    process: {
      title: 'Como trabalhamos',
      steps: [
        { title: 'Análise', desc: 'Estudo do seu negócio, concorrência e público-alvo' },
        { title: 'Arquitetura', desc: 'Definição da estrutura de páginas e navegação' },
        { title: 'Conteúdo', desc: 'Organização e otimização dos textos e imagens' },
        { title: 'Design UI/UX', desc: 'Criação da interface focada na experiência do utilizador' },
        { title: 'Programação', desc: 'Desenvolvimento com tecnologias modernas e seguras' },
        { title: 'Entrega', desc: 'Lançamento, formação e suporte pós-venda' }
      ]
    },
    portfolio: {
      title: 'Projetos anteriores',
      subtitle: 'Websites informativos que desenvolvemos para empresas'
    },
    benefits: {
      title: 'Benefícios',
      items: [
        { title: 'Credibilidade', desc: 'Presença profissional que transmite confiança' },
        { title: 'Visibilidade', desc: 'Melhor posicionamento nos motores de busca' },
        { title: 'Escalabilidade', desc: 'Estrutura preparada para crescer com o negócio' },
        { title: 'Suporte Contínuo', desc: 'Assistência técnica e atualizações regulares' }
      ]
    },
    cta: {
      title: 'Leve a sua empresa para o digital',
      subtitle: 'Solicite uma proposta personalizada para o seu website informativo',
      button: 'Solicitar Proposta'
    }
  },

  ecommerce: {
    title: 'E-commerce',
    subtitle: 'Lojas online otimizadas para vender os seus produtos de forma eficiente',
    description: 'Criamos plataformas de e-commerce completas e seguras, preparadas para impulsionar as suas vendas online. Soluções personalizadas com gestão de produtos, pagamentos e envios integrados.',
    includes: {
      title: 'O que inclui',
      items: [
        { title: 'Catálogo de Produtos', desc: 'Sistema completo de gestão de produtos e categorias' },
        { title: 'Carrinho de Compras', desc: 'Experiência de compra intuitiva e segura' },
        { title: 'Pagamentos Online', desc: 'Integração com gateways de pagamento seguros' },
        { title: 'Gestão de Stocks', desc: 'Controlo automático de inventário e disponibilidade' },
        { title: 'Área de Cliente', desc: 'Portal para histórico de compras e dados pessoais' },
        { title: 'Painel Administrativo', desc: 'Dashboard completo para gerir toda a loja' }
      ]
    },
    process: {
      title: 'Como trabalhamos',
      steps: [
        { title: 'Estratégia', desc: 'Definição do modelo de negócio e objetivos comerciais' },
        { title: 'Plataforma', desc: 'Escolha da tecnologia adequada ao seu projeto' },
        { title: 'Design', desc: 'Interface focada em conversão e experiência de compra' },
        { title: 'Integrações', desc: 'Configuração de pagamentos, envios e sistemas' },
        { title: 'Testes', desc: 'Validação de todo o processo de compra' },
        { title: 'Lançamento', desc: 'Publicação e formação para gestão da loja' }
      ]
    },
    portfolio: {
      title: 'Projetos anteriores',
      subtitle: 'Lojas online que desenvolvemos e que estão a vender'
    },
    benefits: {
      title: 'Benefícios',
      items: [
        { title: 'Vendas 24/7', desc: 'Loja aberta todos os dias, a qualquer hora' },
        { title: 'Alcance Global', desc: 'Venda para qualquer lugar do mundo' },
        { title: 'Automação', desc: 'Processos automatizados que poupam tempo' },
        { title: 'Análise de Dados', desc: 'Relatórios detalhados sobre vendas e clientes' }
      ]
    },
    cta: {
      title: 'Comece a vender online hoje',
      subtitle: 'Peça um orçamento para a sua loja online e aumente as suas vendas',
      button: 'Pedir Orçamento'
    }
  },

  // Identidade Visual Page
  'identidadeVisual.meta.title': 'Identidade Visual - Criação de Marca Profissional | MidiaHost',
  'identidadeVisual.meta.description': 'Criamos identidades visuais completas que destacam a sua marca. Logo, paleta de cores, tipografia e manual de marca profissional.',
  'identidadeVisual.meta.keywords': 'identidade visual, criação de logo, branding, design de marca, manual de marca, paleta de cores',
  
  'identidadeVisual.hero.title': 'Identidade Visual',
  'identidadeVisual.hero.subtitle': 'Crie uma marca memorável e profissional',
  'identidadeVisual.hero.description': 'Desenvolvemos identidades visuais completas que transmitem os valores da sua marca e criam conexão emocional com o seu público. Do logo ao manual de marca, garantimos consistência e impacto visual em todos os pontos de contacto.',
  
  'identidadeVisual.includesTitle': 'O Que Inclui',
  'identidadeVisual.includes.logo.title': 'Design de Logo',
  'identidadeVisual.includes.logo.description': 'Criação de logo único e memorável que representa a essência da sua marca',
  'identidadeVisual.includes.colors.title': 'Paleta de Cores',
  'identidadeVisual.includes.colors.description': 'Definição de cores primárias e secundárias com códigos exatos para todas as aplicações',
  'identidadeVisual.includes.typography.title': 'Tipografia',
  'identidadeVisual.includes.typography.description': 'Seleção de fontes que complementam a identidade e garantem legibilidade',
  'identidadeVisual.includes.manual.title': 'Manual de Marca',
  'identidadeVisual.includes.manual.description': 'Guia completo com regras de uso, variações e aplicações corretas da identidade',
  'identidadeVisual.includes.patterns.title': 'Padrões Visuais',
  'identidadeVisual.includes.patterns.description': 'Elementos gráficos complementares como ícones, texturas e padrões',
  'identidadeVisual.includes.files.title': 'Ficheiros Finais',
  'identidadeVisual.includes.files.description': 'Todos os ficheiros em formatos vetoriais e raster para impressão e digital',
  
  'identidadeVisual.processTitle': 'Como Trabalhamos',
  'identidadeVisual.process.discovery.title': 'Descoberta',
  'identidadeVisual.process.discovery.description': 'Reunião inicial para entender a sua marca, valores, público-alvo e objetivos',
  'identidadeVisual.process.research.title': 'Pesquisa',
  'identidadeVisual.process.research.description': 'Análise de mercado, concorrência e tendências do setor',
  'identidadeVisual.process.concepts.title': 'Conceitos',
  'identidadeVisual.process.concepts.description': 'Desenvolvimento de 3 propostas criativas diferentes para escolha',
  'identidadeVisual.process.refinement.title': 'Refinamento',
  'identidadeVisual.process.refinement.description': 'Ajustes e melhorias no conceito escolhido até à perfeição',
  'identidadeVisual.process.system.title': 'Sistema Visual',
  'identidadeVisual.process.system.description': 'Criação de todos os elementos complementares e aplicações da marca',
  'identidadeVisual.process.delivery.title': 'Entrega',
  'identidadeVisual.process.delivery.description': 'Entrega do manual de marca e todos os ficheiros finais organizados',
  
  'identidadeVisual.portfolioTitle': 'Projetos Anteriores',
  'identidadeVisual.portfolio.tech.title': 'Startup Tecnológica',
  'identidadeVisual.portfolio.tech.description': 'Identidade visual moderna e minimalista para empresa de software',
  'identidadeVisual.portfolio.restaurant.title': 'Restaurante Premium',
  'identidadeVisual.portfolio.restaurant.description': 'Branding sofisticado para restaurante de alta gastronomia',
  'identidadeVisual.portfolio.fitness.title': 'Centro de Fitness',
  'identidadeVisual.portfolio.fitness.description': 'Identidade energética e motivadora para ginásio e wellness',
  
  'identidadeVisual.benefitsTitle': 'Benefícios',
  'identidadeVisual.benefits.recognition.title': 'Reconhecimento Imediato',
  'identidadeVisual.benefits.recognition.description': 'Uma identidade forte torna a sua marca facilmente reconhecível e memorável',
  'identidadeVisual.benefits.credibility.title': 'Credibilidade Profissional',
  'identidadeVisual.benefits.credibility.description': 'Design profissional transmite confiança e seriedade ao seu público',
  'identidadeVisual.benefits.consistency.title': 'Consistência Visual',
  'identidadeVisual.benefits.consistency.description': 'Manual de marca garante aplicação correta em todos os materiais',
  'identidadeVisual.benefits.connection.title': 'Conexão Emocional',
  'identidadeVisual.benefits.connection.description': 'Identidade bem desenvolvida cria vínculo emocional com clientes',
  
  'identidadeVisual.cta.title': 'Pronto para Criar a Sua Marca?',
  'identidadeVisual.cta.description': 'Vamos desenvolver uma identidade visual que destaca o seu negócio e conquista clientes.',
  'identidadeVisual.cta.button': 'Pedir Proposta',

  // Materiais Promocionais Page
  'materiaisPromocionais.meta.title': 'Materiais Promocionais - Design para Marketing Digital | MidiaHost',
  'materiaisPromocionais.meta.description': 'Criamos materiais promocionais impactantes para redes sociais, email marketing, banners digitais e campanhas publicitárias.',
  'materiaisPromocionais.meta.keywords': 'materiais promocionais, design para redes sociais, email marketing, banners digitais, marketing visual',
  
  'materiaisPromocionais.hero.title': 'Materiais Promocionais',
  'materiaisPromocionais.hero.subtitle': 'Destaque-se com design promocional impactante',
  'materiaisPromocionais.hero.description': 'Criamos materiais promocionais que captam atenção e geram resultados. De posts para redes sociais a campanhas de email marketing, desenvolvemos conteúdo visual que converte e fortalece a sua presença digital.',
  
  'materiaisPromocionais.includesTitle': 'O Que Inclui',
  'materiaisPromocionais.includes.social.title': 'Posts para Redes Sociais',
  'materiaisPromocionais.includes.social.description': 'Design de posts, stories e capas para Instagram, Facebook, LinkedIn e outras plataformas',
  'materiaisPromocionais.includes.banners.title': 'Banners Digitais',
  'materiaisPromocionais.includes.banners.description': 'Banners para websites, Google Ads e campanhas publicitárias online',
  'materiaisPromocionais.includes.email.title': 'Email Marketing',
  'materiaisPromocionais.includes.email.description': 'Templates profissionais para newsletters e campanhas de email',
  'materiaisPromocionais.includes.presentations.title': 'Apresentações',
  'materiaisPromocionais.includes.presentations.description': 'Slides corporativos e apresentações comerciais impactantes',
  'materiaisPromocionais.includes.promotional.title': 'Materiais Promocionais',
  'materiaisPromocionais.includes.promotional.description': 'Cupões, vouchers, anúncios e outros materiais de promoção',
  'materiaisPromocionais.includes.infographics.title': 'Infográficos',
  'materiaisPromocionais.includes.infographics.description': 'Visualização de dados e informações de forma atrativa e clara',
  
  'materiaisPromocionais.processTitle': 'Como Trabalhamos',
  'materiaisPromocionais.process.briefing.title': 'Briefing',
  'materiaisPromocionais.process.briefing.description': 'Definição de objetivos, público-alvo e mensagem da campanha',
  'materiaisPromocionais.process.strategy.title': 'Estratégia Visual',
  'materiaisPromocionais.process.strategy.description': 'Planeamento do conceito criativo e linha visual dos materiais',
  'materiaisPromocionais.process.concepts.title': 'Criação',
  'materiaisPromocionais.process.concepts.description': 'Desenvolvimento dos designs com base na estratégia definida',
  'materiaisPromocionais.process.production.title': 'Produção',
  'materiaisPromocionais.process.production.description': 'Finalização de todos os materiais nos formatos necessários',
  'materiaisPromocionais.process.review.title': 'Revisão',
  'materiaisPromocionais.process.review.description': 'Ajustes finais com base no seu feedback',
  'materiaisPromocionais.process.delivery.title': 'Entrega',
  'materiaisPromocionais.process.delivery.description': 'Entrega dos ficheiros otimizados para cada plataforma',
  
  'materiaisPromocionais.portfolioTitle': 'Projetos Anteriores',
  'materiaisPromocionais.portfolio.social.title': 'Campanha Redes Sociais',
  'materiaisPromocionais.portfolio.social.description': 'Série de posts e stories para lançamento de produto',
  'materiaisPromocionais.portfolio.email.title': 'Email Marketing',
  'materiaisPromocionais.portfolio.email.description': 'Templates de newsletter para campanha mensal',
  'materiaisPromocionais.portfolio.banners.title': 'Banners Publicitários',
  'materiaisPromocionais.portfolio.banners.description': 'Conjunto de banners para campanha Google Ads',
  
  'materiaisPromocionais.benefitsTitle': 'Benefícios',
  'materiaisPromocionais.benefits.visibility.title': 'Maior Visibilidade',
  'materiaisPromocionais.benefits.visibility.description': 'Materiais bem desenhados destacam-se e captam mais atenção',
  'materiaisPromocionais.benefits.engagement.title': 'Mais Engagement',
  'materiaisPromocionais.benefits.engagement.description': 'Design atrativo gera mais interações e partilhas',
  'materiaisPromocionais.benefits.conversion.title': 'Melhor Conversão',
  'materiaisPromocionais.benefits.conversion.description': 'Materiais profissionais aumentam a taxa de conversão',
  'materiaisPromocionais.benefits.branding.title': 'Reforço de Marca',
  'materiaisPromocionais.benefits.branding.description': 'Consistência visual fortalece a identidade da marca',
  
  'materiaisPromocionais.cta.title': 'Pronto para Impulsionar o Seu Marketing?',
  'materiaisPromocionais.cta.description': 'Vamos criar materiais promocionais que destacam a sua marca e geram resultados.',
  'materiaisPromocionais.cta.button': 'Pedir Orçamento',

  // Design para Impressão Page
  'designImpressao.meta.title': 'Design para Impressão - Materiais Gráficos Profissionais | MidiaHost',
  'designImpressao.meta.description': 'Criamos design para impressão de alta qualidade: flyers, posters, banners, catálogos, cartões de visita e embalagens.',
  'designImpressao.meta.keywords': 'design para impressão, flyers, posters, banners, catálogos, cartões de visita, embalagens',
  
  'designImpressao.hero.title': 'Design para Impressão',
  'designImpressao.hero.subtitle': 'Materiais impressos de alta qualidade',
  'designImpressao.hero.description': 'Desenvolvemos design para impressão com atenção aos detalhes técnicos e qualidade gráfica. De flyers a embalagens, criamos materiais que impressionam e comunicam eficazmente a sua mensagem no mundo físico.',
  
  'designImpressao.includesTitle': 'O Que Inclui',
  'designImpressao.includes.flyers.title': 'Flyers e Folhetos',
  'designImpressao.includes.flyers.description': 'Design de flyers promocionais e folhetos informativos com acabamento profissional',
  'designImpressao.includes.posters.title': 'Posters e Cartazes',
  'designImpressao.includes.posters.description': 'Cartazes impactantes para eventos, promoções e campanhas publicitárias',
  'designImpressao.includes.banners.title': 'Banners e Roll-ups',
  'designImpressao.includes.banners.description': 'Banners físicos e roll-ups para eventos, feiras e pontos de venda',
  'designImpressao.includes.catalogs.title': 'Catálogos e Brochuras',
  'designImpressao.includes.catalogs.description': 'Catálogos de produtos e brochuras corporativas com layout profissional',
  'designImpressao.includes.cards.title': 'Cartões de Visita',
  'designImpressao.includes.cards.description': 'Cartões de visita elegantes que causam boa primeira impressão',
  'designImpressao.includes.packaging.title': 'Embalagens',
  'designImpressao.includes.packaging.description': 'Design de embalagens que protegem e valorizam os seus produtos',
  
  'designImpressao.processTitle': 'Como Trabalhamos',
  'designImpressao.process.briefing.title': 'Briefing',
  'designImpressao.process.briefing.description': 'Definição de objetivos, especificações técnicas e requisitos de impressão',
  'designImpressao.process.concept.title': 'Conceito',
  'designImpressao.process.concept.description': 'Desenvolvimento do conceito criativo adequado ao material',
  'designImpressao.process.design.title': 'Design',
  'designImpressao.process.design.description': 'Criação do layout com atenção a cores CMYK e resolução',
  'designImpressao.process.prepress.title': 'Pré-impressão',
  'designImpressao.process.prepress.description': 'Preparação técnica dos ficheiros com sangrias e marcas de corte',
  'designImpressao.process.approval.title': 'Aprovação',
  'designImpressao.process.approval.description': 'Revisão final e aprovação antes do envio para impressão',
  'designImpressao.process.production.title': 'Produção',
  'designImpressao.process.production.description': 'Acompanhamento da impressão e controlo de qualidade',
  
  'designImpressao.portfolioTitle': 'Projetos Anteriores',
  'designImpressao.portfolio.brochure.title': 'Brochura Corporativa',
  'designImpressao.portfolio.brochure.description': 'Catálogo institucional de 24 páginas para empresa de serviços',
  'designImpressao.portfolio.poster.title': 'Poster de Evento',
  'designImpressao.portfolio.poster.description': 'Cartaz promocional para festival de música',
  'designImpressao.portfolio.packaging.title': 'Embalagem Premium',
  'designImpressao.portfolio.packaging.description': 'Design de embalagem para linha de produtos gourmet',
  
  'designImpressao.benefitsTitle': 'Benefícios',
  'designImpressao.benefits.quality.title': 'Qualidade Garantida',
  'designImpressao.benefits.quality.description': 'Ficheiros preparados tecnicamente para impressão perfeita',
  'designImpressao.benefits.tangible.title': 'Impacto Tangível',
  'designImpressao.benefits.tangible.description': 'Materiais físicos criam conexão mais forte com o público',
  'designImpressao.benefits.professional.title': 'Imagem Profissional',
  'designImpressao.benefits.professional.description': 'Materiais impressos de qualidade transmitem profissionalismo',
  'designImpressao.benefits.durability.title': 'Durabilidade',
  'designImpressao.benefits.durability.description': 'Materiais impressos têm vida útil longa e presença constante',
  
  'designImpressao.cta.title': 'Pronto para Impressionar?',
  'designImpressao.cta.description': 'Vamos criar materiais impressos que destacam a sua marca no mundo físico.',
  'designImpressao.cta.button': 'Pedir Orçamento',

  // Fotografia Service
  'services.fotografia.meta.title': 'Fotografia Profissional | MidiaHost',
  'services.fotografia.meta.description': 'Serviços de fotografia profissional para eventos, marcas e projetos. Capturamos momentos autênticos com qualidade técnica superior e entrega rápida.',
  'services.fotografia.meta.keywords': 'fotografia profissional, fotografia de eventos, fotografia corporativa, fotografia de produtos, fotografia de marca',
  'services.fotografia.hero.title': 'Fotografia Profissional',
  'services.fotografia.hero.subtitle': 'Capturamos a essência da sua marca',
  'services.fotografia.hero.description': 'Serviços de fotografia profissional para eventos corporativos, produtos, retratos e branding. Transformamos momentos em imagens memoráveis com qualidade técnica superior e visão criativa.',
  'services.fotografia.includes.title': 'O Que Inclui',
  'services.fotografia.includes.item1.title': 'Cobertura Completa',
  'services.fotografia.includes.item1.description': 'Cobertura fotográfica completa do evento ou sessão com múltiplos ângulos e perspetivas.',
  'services.fotografia.includes.item2.title': 'Fotografia Corporativa',
  'services.fotografia.includes.item2.description': 'Retratos profissionais, headshots e fotografia de equipa para uso corporativo.',
  'services.fotografia.includes.item3.title': 'Fotografia de Produto',
  'services.fotografia.includes.item3.description': 'Imagens de alta qualidade de produtos para e-commerce, catálogos e marketing.',
  'services.fotografia.includes.item4.title': 'Edição Profissional',
  'services.fotografia.includes.item4.description': 'Tratamento e edição profissional de todas as fotografias selecionadas.',
  'services.fotografia.includes.item5.title': 'Galeria Online',
  'services.fotografia.includes.item5.description': 'Acesso a galeria online privada para visualização e download das imagens.',
  'services.fotografia.includes.item6.title': 'Entrega Rápida',
  'services.fotografia.includes.item6.description': 'Entrega das fotografias editadas em alta resolução em até 7 dias úteis.',
  'services.fotografia.process.title': 'Como Trabalhamos',
  'services.fotografia.process.step1.title': 'Briefing Inicial',
  'services.fotografia.process.step1.description': 'Reunião para entender objetivos, estilo desejado e requisitos específicos do projeto.',
  'services.fotografia.process.step2.title': 'Planeamento',
  'services.fotografia.process.step2.description': 'Definição de locais, horários, equipamento necessário e shot list detalhada.',
  'services.fotografia.process.step3.title': 'Preparação Técnica',
  'services.fotografia.process.step3.description': 'Configuração de equipamento, iluminação e preparação de todos os detalhes técnicos.',
  'services.fotografia.process.step4.title': 'Sessão Fotográfica',
  'services.fotografia.process.step4.description': 'Execução da sessão com direção profissional e captura de todas as imagens planeadas.',
  'services.fotografia.process.step5.title': 'Seleção e Edição',
  'services.fotografia.process.step5.description': 'Curadoria das melhores imagens e edição profissional com correção de cor e retoque.',
  'services.fotografia.process.step6.title': 'Entrega Final',
  'services.fotografia.process.step6.description': 'Entrega das fotografias em alta resolução através de galeria online privada.',
  'services.fotografia.portfolio.title': 'Trabalhos Anteriores',
  'services.fotografia.portfolio.project1.title': 'Evento Corporativo Tech Summit',
  'services.fotografia.portfolio.project1.description': 'Cobertura completa de conferência tecnológica com 500+ participantes.',
  'services.fotografia.portfolio.project2.title': 'Catálogo de Produtos Premium',
  'services.fotografia.portfolio.project2.description': 'Fotografia de produto para marca de luxo com 50+ itens fotografados.',
  'services.fotografia.portfolio.project3.title': 'Retratos Corporativos Executive Team',
  'services.fotografia.portfolio.project3.description': 'Sessão de retratos profissionais para equipa executiva de empresa multinacional.',
  'services.fotografia.benefits.title': 'Porquê Escolher-nos',
  'services.fotografia.benefits.benefit1.title': 'Equipamento Profissional',
  'services.fotografia.benefits.benefit1.description': 'Câmaras full-frame, lentes premium e iluminação profissional para máxima qualidade.',
  'services.fotografia.benefits.benefit2.title': 'Fotógrafos Experientes',
  'services.fotografia.benefits.benefit2.description': 'Equipa com anos de experiência em fotografia comercial e eventos corporativos.',
  'services.fotografia.benefits.benefit3.title': 'Iluminação Profissional',
  'services.fotografia.benefits.benefit3.description': 'Setup de iluminação adequado para cada situação, garantindo resultados consistentes.',
  'services.fotografia.benefits.benefit4.title': 'Entrega Digital Rápida',
  'services.fotografia.benefits.benefit4.description': 'Galeria online com download em alta resolução e formatos otimizados para web.',
  'services.fotografia.cta.title': 'Pronto para Capturar Momentos Memoráveis?',
  'services.fotografia.cta.description': 'Entre em contacto connosco para discutir o seu projeto fotográfico e receber uma proposta personalizada.',
  'services.fotografia.cta.button': 'Pedir Orçamento',

  // Videografia Service
  'services.videografia.meta.title': 'Videografia Profissional | MidiaHost',
  'services.videografia.meta.description': 'Produção de vídeo profissional para marcas, eventos e storytelling. Criamos conteúdo audiovisual de alta qualidade que comunica e emociona.',
  'services.videografia.meta.keywords': 'videografia profissional, produção de vídeo, vídeo corporativo, vídeo promocional, storytelling visual',
  'services.videografia.hero.title': 'Videografia Profissional',
  'services.videografia.hero.subtitle': 'Contamos histórias através de imagens em movimento',
  'services.videografia.hero.description': 'Produção de vídeo profissional para conteúdo promocional, institucional e storytelling de marca. Criamos narrativas visuais impactantes que conectam com a sua audiência.',
  'services.videografia.includes.title': 'O Que Inclui',
  'services.videografia.includes.item1.title': 'Produção Completa',
  'services.videografia.includes.item1.description': 'Pré-produção, filmagem e pós-produção com equipa técnica completa.',
  'services.videografia.includes.item2.title': 'Filmagem Multi-Câmara',
  'services.videografia.includes.item2.description': 'Captura com múltiplas câmaras para cobertura completa e ângulos dinâmicos.',
  'services.videografia.includes.item3.title': 'Áudio Profissional',
  'services.videografia.includes.item3.description': 'Gravação de áudio com equipamento profissional e microfones de qualidade.',
  'services.videografia.includes.item4.title': 'Edição Avançada',
  'services.videografia.includes.item4.description': 'Edição profissional com correção de cor, motion graphics e efeitos visuais.',
  'services.videografia.includes.item5.title': 'Legendas e Grafismos',
  'services.videografia.includes.item5.description': 'Criação de legendas, lower thirds e elementos gráficos personalizados.',
  'services.videografia.includes.item6.title': 'Múltiplos Formatos',
  'services.videografia.includes.item6.description': 'Entrega em diferentes formatos otimizados para web, redes sociais e TV.',
  'services.videografia.process.title': 'Como Trabalhamos',
  'services.videografia.process.step1.title': 'Conceito e Briefing',
  'services.videografia.process.step1.description': 'Definição de objetivos, mensagem, público-alvo e conceito criativo do vídeo.',
  'services.videografia.process.step2.title': 'Pré-Produção',
  'services.videografia.process.step2.description': 'Desenvolvimento de script, storyboard, planeamento de locações e casting.',
  'services.videografia.process.step3.title': 'Preparação Técnica',
  'services.videografia.process.step3.description': 'Seleção de equipamento, testes técnicos e preparação de toda a logística.',
  'services.videografia.process.step4.title': 'Filmagem',
  'services.videografia.process.step4.description': 'Execução da produção com direção profissional e captura de todas as cenas.',
  'services.videografia.process.step5.title': 'Pós-Produção',
  'services.videografia.process.step5.description': 'Edição, correção de cor, sound design, motion graphics e finalização.',
  'services.videografia.process.step6.title': 'Entrega e Revisões',
  'services.videografia.process.step6.description': 'Apresentação do vídeo final com até 2 rondas de revisões incluídas.',
  'services.videografia.portfolio.title': 'Trabalhos Anteriores',
  'services.videografia.portfolio.project1.title': 'Vídeo Corporativo Tech Company',
  'services.videografia.portfolio.project1.description': 'Vídeo institucional de 3 minutos apresentando cultura e valores da empresa.',
  'services.videografia.portfolio.project2.title': 'Campanha Brand Storytelling',
  'services.videografia.portfolio.project2.description': 'Série de 5 vídeos emocionais contando histórias reais de clientes.',
  'services.videografia.portfolio.project3.title': 'Vídeo Promocional de Produto',
  'services.videografia.portfolio.project3.description': 'Vídeo de lançamento de produto com demonstração e depoimentos.',
  'services.videografia.benefits.title': 'Porquê Escolher-nos',
  'services.videografia.benefits.benefit1.title': 'Qualidade Cinematográfica',
  'services.videografia.benefits.benefit1.description': 'Filmagem em 4K com câmaras cinema e lentes profissionais para qualidade superior.',
  'services.videografia.benefits.benefit2.title': 'Narrativa Criativa',
  'services.videografia.benefits.benefit2.description': 'Storytelling envolvente que comunica a mensagem de forma emocional e eficaz.',
  'services.videografia.benefits.benefit3.title': 'Produção Eficiente',
  'services.videografia.benefits.benefit3.description': 'Processos otimizados que garantem entregas dentro do prazo sem comprometer qualidade.',
  'services.videografia.benefits.benefit4.title': 'Versatilidade de Formatos',
  'services.videografia.benefits.benefit4.description': 'Adaptação do conteúdo para diferentes plataformas e necessidades de distribuição.',
  'services.videografia.cta.title': 'Pronto para Criar Conteúdo Visual Impactante?',
  'services.videografia.cta.description': 'Entre em contacto connosco para discutir o seu projeto de vídeo e receber uma proposta personalizada.',
  'services.videografia.cta.button': 'Pedir Orçamento',

  // Streaming ao Vivo Service
  'services.streaming.meta.title': 'Streaming ao Vivo Profissional | MidiaHost',
  'services.streaming.meta.description': 'Serviços de streaming ao vivo para eventos, conferências e transmissões online. Tecnologia profissional para alcançar audiências globais em tempo real.',
  'services.streaming.meta.keywords': 'streaming ao vivo, transmissão online, live streaming, eventos virtuais, webcast profissional',
  'services.streaming.hero.title': 'Streaming ao Vivo',
  'services.streaming.hero.subtitle': 'Conecte-se com audiências globais em tempo real',
  'services.streaming.hero.description': 'Serviços profissionais de streaming ao vivo para eventos, conferências e transmissões online. Tecnologia de ponta e equipa experiente para garantir transmissões estáveis e de alta qualidade.',
  'services.streaming.includes.title': 'O Que Inclui',
  'services.streaming.includes.item1.title': 'Transmissão Multi-Plataforma',
  'services.streaming.includes.item1.description': 'Streaming simultâneo para YouTube, Facebook, LinkedIn e plataformas personalizadas.',
  'services.streaming.includes.item2.title': 'Múltiplas Câmaras',
  'services.streaming.includes.item2.description': 'Setup com 2-4 câmaras para cobertura dinâmica e switching em tempo real.',
  'services.streaming.includes.item3.title': 'Áudio Profissional',
  'services.streaming.includes.item3.description': 'Sistema de áudio com microfones wireless e mixing profissional.',
  'services.streaming.includes.item4.title': 'Grafismos ao Vivo',
  'services.streaming.includes.item4.description': 'Lower thirds, slides de apresentação e overlays gráficos em tempo real.',
  'services.streaming.includes.item5.title': 'Moderação de Chat',
  'services.streaming.includes.item5.description': 'Gestão de comentários e interação com audiência durante a transmissão.',
  'services.streaming.includes.item6.title': 'Gravação e Arquivo',
  'services.streaming.includes.item6.description': 'Gravação em alta qualidade para arquivo e disponibilização posterior.',
  'services.streaming.process.title': 'Como Trabalhamos',
  'services.streaming.process.step1.title': 'Planeamento Técnico',
  'services.streaming.process.step1.description': 'Análise de requisitos, definição de plataformas e planeamento de setup técnico.',
  'services.streaming.process.step2.title': 'Visita ao Local',
  'services.streaming.process.step2.description': 'Avaliação do espaço, teste de internet e planeamento de posicionamento de equipamento.',
  'services.streaming.process.step3.title': 'Setup e Testes',
  'services.streaming.process.step3.description': 'Instalação de equipamento, configuração de streaming e testes técnicos completos.',
  'services.streaming.process.step4.title': 'Ensaio Técnico',
  'services.streaming.process.step4.description': 'Rehearsal com oradores para testar áudio, vídeo e fluxo da transmissão.',
  'services.streaming.process.step5.title': 'Transmissão ao Vivo',
  'services.streaming.process.step5.description': 'Execução da transmissão com monitorização constante e gestão técnica.',
  'services.streaming.process.step6.title': 'Pós-Evento',
  'services.streaming.process.step6.description': 'Entrega de gravação editada e relatório de métricas de audiência.',
  'services.streaming.portfolio.title': 'Trabalhos Anteriores',
  'services.streaming.portfolio.project1.title': 'Conferência Tech Summit 2024',
  'services.streaming.portfolio.project1.description': 'Streaming de conferência de 2 dias com 5000+ espectadores online simultâneos.',
  'services.streaming.portfolio.project2.title': 'Webinar Corporativo Mensal',
  'services.streaming.portfolio.project2.description': 'Série de webinars mensais com apresentações e Q&A interativo.',
  'services.streaming.portfolio.project3.title': 'Evento Híbrido de Lançamento',
  'services.streaming.portfolio.project3.description': 'Evento de lançamento de produto com audiência presencial e 2000+ online.',
  'services.streaming.benefits.title': 'Porquê Escolher-nos',
  'services.streaming.benefits.benefit1.title': 'Alcance Global',
  'services.streaming.benefits.benefit1.description': 'Transmita para audiências em qualquer parte do mundo sem limitações geográficas.',
  'services.streaming.benefits.benefit2.title': 'Estabilidade Garantida',
  'services.streaming.benefits.benefit2.description': 'Redundância de internet e equipamento backup para garantir transmissão sem falhas.',
  'services.streaming.benefits.benefit3.title': 'Suporte Técnico Dedicado',
  'services.streaming.benefits.benefit3.description': 'Equipa técnica presente durante todo o evento para resolver qualquer situação.',
  'services.streaming.benefits.benefit4.title': 'Métricas e Analytics',
  'services.streaming.benefits.benefit4.description': 'Relatórios detalhados de audiência, engagement e performance da transmissão.',
  'services.streaming.cta.title': 'Pronto para Transmitir o Seu Evento?',
  'services.streaming.cta.description': 'Entre em contacto connosco para discutir o seu evento e receber uma proposta personalizada de streaming.',
  'services.streaming.cta.button': 'Pedir Orçamento',

  // Identidade Visual Page
  'identidadeVisual.meta.title': 'Identidade Visual - Criação de Marca Profissional | MidiaHost',
  'identidadeVisual.meta.description': 'Criamos identidades visuais completas que destacam a sua marca. Logo, paleta de cores, tipografia e manual de marca profissional.',
  'identidadeVisual.meta.keywords': 'identidade visual, criação de logo, branding, design de marca, manual de marca, paleta de cores',
  
  'identidadeVisual.hero.title': 'Identidade Visual',
  'identidadeVisual.hero.subtitle': 'Crie uma marca memorável e profissional',
  'identidadeVisual.hero.description': 'Desenvolvemos identidades visuais completas que transmitem os valores da sua marca e criam conexão emocional com o seu público. Do logo ao manual de marca, garantimos consistência e impacto visual em todos os pontos de contacto.',
  
  'identidadeVisual.includesTitle': 'O Que Inclui',
  'identidadeVisual.includes.logo.title': 'Design de Logo',
  'identidadeVisual.includes.logo.description': 'Criação de logo único e memorável que representa a essência da sua marca',
  'identidadeVisual.includes.colors.title': 'Paleta de Cores',
  'identidadeVisual.includes.colors.description': 'Definição de cores primárias e secundárias com códigos exatos para todas as aplicações',
  'identidadeVisual.includes.typography.title': 'Tipografia',
  'identidadeVisual.includes.typography.description': 'Seleção de fontes que complementam a identidade e garantem legibilidade',
  'identidadeVisual.includes.manual.title': 'Manual de Marca',
  'identidadeVisual.includes.manual.description': 'Guia completo com regras de uso, variações e aplicações corretas da identidade',
  'identidadeVisual.includes.patterns.title': 'Padrões Visuais',
  'identidadeVisual.includes.patterns.description': 'Elementos gráficos complementares como ícones, texturas e padrões',
  'identidadeVisual.includes.files.title': 'Ficheiros Finais',
  'identidadeVisual.includes.files.description': 'Todos os ficheiros em formatos vetoriais e raster para impressão e digital',
  
  'identidadeVisual.processTitle': 'Como Trabalhamos',
  'identidadeVisual.process.discovery.title': 'Descoberta',
  'identidadeVisual.process.discovery.description': 'Reunião inicial para entender a sua marca, valores, público-alvo e objetivos',
  'identidadeVisual.process.research.title': 'Pesquisa',
  'identidadeVisual.process.research.description': 'Análise de mercado, concorrência e tendências do setor',
  'identidadeVisual.process.concepts.title': 'Conceitos',
  'identidadeVisual.process.concepts.description': 'Desenvolvimento de 3 propostas criativas diferentes para escolha',
  'identidadeVisual.process.refinement.title': 'Refinamento',
  'identidadeVisual.process.refinement.description': 'Ajustes e melhorias no conceito escolhido até à perfeição',
  'identidadeVisual.process.system.title': 'Sistema Visual',
  'identidadeVisual.process.system.description': 'Criação de todos os elementos complementares e aplicações da marca',
  'identidadeVisual.process.delivery.title': 'Entrega',
  'identidadeVisual.process.delivery.description': 'Entrega do manual de marca e todos os ficheiros finais organizados',
  
  'identidadeVisual.portfolioTitle': 'Projetos Anteriores',
  'identidadeVisual.portfolio.tech.title': 'Startup Tecnológica',
  'identidadeVisual.portfolio.tech.description': 'Identidade visual moderna e minimalista para empresa de software',
  'identidadeVisual.portfolio.restaurant.title': 'Restaurante Premium',
  'identidadeVisual.portfolio.restaurant.description': 'Branding sofisticado para restaurante de alta gastronomia',
  'identidadeVisual.portfolio.fitness.title': 'Centro de Fitness',
  'identidadeVisual.portfolio.fitness.description': 'Identidade energética e motivadora para ginásio e wellness',
  
  'identidadeVisual.benefitsTitle': 'Benefícios',
  'identidadeVisual.benefits.recognition.title': 'Reconhecimento Imediato',
  'identidadeVisual.benefits.recognition.description': 'Uma identidade forte torna a sua marca facilmente reconhecível e memorável',
  'identidadeVisual.benefits.credibility.title': 'Credibilidade Profissional',
  'identidadeVisual.benefits.credibility.description': 'Design profissional transmite confiança e seriedade ao seu público',
  'identidadeVisual.benefits.consistency.title': 'Consistência Visual',
  'identidadeVisual.benefits.consistency.description': 'Manual de marca garante aplicação correta em todos os materiais',
  'identidadeVisual.benefits.connection.title': 'Conexão Emocional',
  'identidadeVisual.benefits.connection.description': 'Identidade bem desenvolvida cria vínculo emocional com clientes',
  
  'identidadeVisual.cta.title': 'Pronto para Criar a Sua Marca?',
  'identidadeVisual.cta.description': 'Vamos desenvolver uma identidade visual que destaca o seu negócio e conquista clientes.',
  'identidadeVisual.cta.button': 'Pedir Proposta',

  // Materiais Promocionais Page
  'materiaisPromocionais.meta.title': 'Materiais Promocionais - Design para Marketing Digital | MidiaHost',
  'materiaisPromocionais.meta.description': 'Criamos materiais promocionais impactantes para redes sociais, email marketing, banners digitais e campanhas publicitárias.',
  'materiaisPromocionais.meta.keywords': 'materiais promocionais, design para redes sociais, email marketing, banners digitais, marketing visual',
  
  'materiaisPromocionais.hero.title': 'Materiais Promocionais',
  'materiaisPromocionais.hero.subtitle': 'Destaque-se com design promocional impactante',
  'materiaisPromocionais.hero.description': 'Criamos materiais promocionais que captam atenção e geram resultados. De posts para redes sociais a campanhas de email marketing, desenvolvemos conteúdo visual que converte e fortalece a sua presença digital.',
  
  'materiaisPromocionais.includesTitle': 'O Que Inclui',
  'materiaisPromocionais.includes.social.title': 'Posts para Redes Sociais',
  'materiaisPromocionais.includes.social.description': 'Design de posts, stories e capas para Instagram, Facebook, LinkedIn e outras plataformas',
  'materiaisPromocionais.includes.banners.title': 'Banners Digitais',
  'materiaisPromocionais.includes.banners.description': 'Banners para websites, Google Ads e campanhas publicitárias online',
  'materiaisPromocionais.includes.email.title': 'Email Marketing',
  'materiaisPromocionais.includes.email.description': 'Templates profissionais para newsletters e campanhas de email',
  'materiaisPromocionais.includes.presentations.title': 'Apresentações',
  'materiaisPromocionais.includes.presentations.description': 'Slides corporativos e apresentações comerciais impactantes',
  'materiaisPromocionais.includes.promotional.title': 'Materiais Promocionais',
  'materiaisPromocionais.includes.promotional.description': 'Cupões, vouchers, anúncios e outros materiais de promoção',
  'materiaisPromocionais.includes.infographics.title': 'Infográficos',
  'materiaisPromocionais.includes.infographics.description': 'Visualização de dados e informações de forma atrativa e clara',
  
  'materiaisPromocionais.processTitle': 'Como Trabalhamos',
  'materiaisPromocionais.process.briefing.title': 'Briefing',
  'materiaisPromocionais.process.briefing.description': 'Definição de objetivos, público-alvo e mensagem da campanha',
  'materiaisPromocionais.process.strategy.title': 'Estratégia Visual',
  'materiaisPromocionais.process.strategy.description': 'Planeamento do conceito criativo e linha visual dos materiais',
  'materiaisPromocionais.process.concepts.title': 'Criação',
  'materiaisPromocionais.process.concepts.description': 'Desenvolvimento dos designs com base na estratégia definida',
  'materiaisPromocionais.process.production.title': 'Produção',
  'materiaisPromocionais.process.production.description': 'Finalização de todos os materiais nos formatos necessários',
  'materiaisPromocionais.process.review.title': 'Revisão',
  'materiaisPromocionais.process.review.description': 'Ajustes finais com base no seu feedback',
  'materiaisPromocionais.process.delivery.title': 'Entrega',
  'materiaisPromocionais.process.delivery.description': 'Entrega dos ficheiros otimizados para cada plataforma',
  
  'materiaisPromocionais.portfolioTitle': 'Projetos Anteriores',
  'materiaisPromocionais.portfolio.social.title': 'Campanha Redes Sociais',
  'materiaisPromocionais.portfolio.social.description': 'Série de posts e stories para lançamento de produto',
  'materiaisPromocionais.portfolio.email.title': 'Email Marketing',
  'materiaisPromocionais.portfolio.email.description': 'Templates de newsletter para campanha mensal',
  'materiaisPromocionais.portfolio.banners.title': 'Banners Publicitários',
  'materiaisPromocionais.portfolio.banners.description': 'Conjunto de banners para campanha Google Ads',
  
  'materiaisPromocionais.benefitsTitle': 'Benefícios',
  'materiaisPromocionais.benefits.visibility.title': 'Maior Visibilidade',
  'materiaisPromocionais.benefits.visibility.description': 'Materiais bem desenhados destacam-se e captam mais atenção',
  'materiaisPromocionais.benefits.engagement.title': 'Mais Engagement',
  'materiaisPromocionais.benefits.engagement.description': 'Design atrativo gera mais interações e partilhas',
  'materiaisPromocionais.benefits.conversion.title': 'Melhor Conversão',
  'materiaisPromocionais.benefits.conversion.description': 'Materiais profissionais aumentam a taxa de conversão',
  'materiaisPromocionais.benefits.branding.title': 'Reforço de Marca',
  'materiaisPromocionais.benefits.branding.description': 'Consistência visual fortalece a identidade da marca',
  
  'materiaisPromocionais.cta.title': 'Pronto para Impulsionar o Seu Marketing?',
  'materiaisPromocionais.cta.description': 'Vamos criar materiais promocionais que destacam a sua marca e geram resultados.',
  'materiaisPromocionais.cta.button': 'Pedir Orçamento',

  // Design para Impressão Page
  'designImpressao.meta.title': 'Design para Impressão - Materiais Gráficos Profissionais | MidiaHost',
  'designImpressao.meta.description': 'Criamos design para impressão de alta qualidade: flyers, posters, banners, catálogos, cartões de visita e embalagens.',
  'designImpressao.meta.keywords': 'design para impressão, flyers, posters, banners, catálogos, cartões de visita, embalagens',
  
  'designImpressao.hero.title': 'Design para Impressão',
  'designImpressao.hero.subtitle': 'Materiais impressos de alta qualidade',
  'designImpressao.hero.description': 'Desenvolvemos design para impressão com atenção aos detalhes técnicos e qualidade gráfica. De flyers a embalagens, criamos materiais que impressionam e comunicam eficazmente a sua mensagem no mundo físico.',
  
  'designImpressao.includesTitle': 'O Que Inclui',
  'designImpressao.includes.flyers.title': 'Flyers e Folhetos',
  'designImpressao.includes.flyers.description': 'Design de flyers promocionais e folhetos informativos com acabamento profissional',
  'designImpressao.includes.posters.title': 'Posters e Cartazes',
  'designImpressao.includes.posters.description': 'Cartazes impactantes para eventos, promoções e campanhas publicitárias',
  'designImpressao.includes.banners.title': 'Banners e Roll-ups',
  'designImpressao.includes.banners.description': 'Banners físicos e roll-ups para eventos, feiras e pontos de venda',
  'designImpressao.includes.catalogs.title': 'Catálogos e Brochuras',
  'designImpressao.includes.catalogs.description': 'Catálogos de produtos e brochuras corporativas com layout profissional',
  'designImpressao.includes.cards.title': 'Cartões de Visita',
  'designImpressao.includes.cards.description': 'Cartões de visita elegantes que causam boa primeira impressão',
  'designImpressao.includes.packaging.title': 'Embalagens',
  'designImpressao.includes.packaging.description': 'Design de embalagens que protegem e valorizam os seus produtos',
  
  'designImpressao.processTitle': 'Como Trabalhamos',
  'designImpressao.process.briefing.title': 'Briefing',
  'designImpressao.process.briefing.description': 'Definição de objetivos, especificações técnicas e requisitos de impressão',
  'designImpressao.process.concept.title': 'Conceito',
  'designImpressao.process.concept.description': 'Desenvolvimento do conceito criativo adequado ao material',
  'designImpressao.process.design.title': 'Design',
  'designImpressao.process.design.description': 'Criação do layout com atenção a cores CMYK e resolução',
  'designImpressao.process.prepress.title': 'Pré-impressão',
  'designImpressao.process.prepress.description': 'Preparação técnica dos ficheiros com sangrias e marcas de corte',
  'designImpressao.process.approval.title': 'Aprovação',
  'designImpressao.process.approval.description': 'Revisão final e aprovação antes do envio para impressão',
  'designImpressao.process.production.title': 'Produção',
  'designImpressao.process.production.description': 'Acompanhamento da impressão e controlo de qualidade',
  
  'designImpressao.portfolioTitle': 'Projetos Anteriores',
  'designImpressao.portfolio.brochure.title': 'Brochura Corporativa',
  'designImpressao.portfolio.brochure.description': 'Catálogo institucional de 24 páginas para empresa de serviços',
  'designImpressao.portfolio.poster.title': 'Poster de Evento',
  'designImpressao.portfolio.poster.description': 'Cartaz promocional para festival de música',
  'designImpressao.portfolio.packaging.title': 'Embalagem Premium',
  'designImpressao.portfolio.packaging.description': 'Design de embalagem para linha de produtos gourmet',
  
  'designImpressao.benefitsTitle': 'Benefícios',
  'designImpressao.benefits.quality.title': 'Qualidade Garantida',
  'designImpressao.benefits.quality.description': 'Ficheiros preparados tecnicamente para impressão perfeita',
  'designImpressao.benefits.tangible.title': 'Impacto Tangível',
  'designImpressao.benefits.tangible.description': 'Materiais físicos criam conexão mais forte com o público',
  'designImpressao.benefits.professional.title': 'Imagem Profissional',
  'designImpressao.benefits.professional.description': 'Materiais impressos de qualidade transmitem profissionalismo',
  'designImpressao.benefits.durability.title': 'Durabilidade',
  'designImpressao.benefits.durability.description': 'Materiais impressos têm vida útil longa e presença constante',
  
  'designImpressao.cta.title': 'Pronto para Impressionar?',
  'designImpressao.cta.description': 'Vamos criar materiais impressos que destacam a sua marca no mundo físico.',
  'designImpressao.cta.button': 'Pedir Orçamento',
};

export default translations;
